import React, { useState, useContext, useEffect } from 'react';
import { Typography, Card, CardContent, CardMedia, Grid, Box, IconButton, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Context as BlogContext } from "../../context/BlogContext";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteConfirmationDialog from '../../components/DeleteConfirmationDialog';

const BlogScreen = () => {
    const navigate = useNavigate();
    const [blogListData, setBlogListData] = useState([])
    const [blogToDelete, setBlogToDelete] = useState(null);
    const { state: { BlogList, BlogListStatus, DeleteBlogStatus }, getAllBlogs, clearGetAllBlogsStatus, deleteBlog, clearDeleteBlogStatus } = useContext(BlogContext);

    useEffect(() => {
        getAllBlogs()
    }, []);

    useEffect(() => {
        // if (BlogList) {
        //     const sortedBlog = BlogList?.data?.slice().sort((a: _id, b: _id) => b._id - a._id);
        //     setBlogListData(sortedBlog)
        // }
        if (BlogList) {
            const sortedBlog = BlogList?.data?.slice().sort((a, b) =>
                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
            setBlogListData(sortedBlog);
        }
    }, [BlogList])

    useEffect(() => {
        if (DeleteBlogStatus !== "") {
            if (DeleteBlogStatus === 200) {
                // setStatus(200)
                // setOpenAlert(true)
                clearDeleteBlogStatus();
                getAllBlogs();
            } else {
                // setStatus(400)
                // setOpenAlert(true)
            }
        }
    }, [DeleteBlogStatus]);


    const handleDelete = () => {
        if (blogToDelete?._id) {
            deleteBlog(blogToDelete._id);
            setBlogToDelete(null);
        }
    };


    const handleEdit = (post) => {
        navigate('/blog/edit', { state: { post } });
    };

    return (
        <div>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h4" gutterBottom>
                    Blog
                </Typography>
                <Button variant="contained" color="primary"
                    component={Link}
                    to="/blog/create"
                >
                    Create
                </Button>
            </Box>
            {!BlogList || BlogList?.data?.length === 0 ?
                <Typography variant="h6">No blog posts available.</Typography> :
                <Grid container spacing={4}>
                    {blogListData?.map((post) => (
                        <Grid item xs={12} key={post._id}>
                            <Card>
                                <Box display="flex">
                                    <Box display="flex" flex="1" alignItems="center">
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 270, height: 170, objectFit: 'cover' }}
                                            image={post.image}
                                            alt={post.title}
                                        />
                                        <Box ml={2}>
                                            <Typography variant="h6" component="div">
                                                {post.topic}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box flexDirection="column" justifyContent="space-between">
                                        <Box display="flex" justifyContent="flex-end" padding="8px">
                                            <IconButton aria-label="edit" onClick={() => handleEdit(post)}>
                                                <EditIcon color="primary" />
                                            </IconButton>
                                            <IconButton aria-label="delete" color="error" onClick={() => setBlogToDelete(post)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            }
            <DeleteConfirmationDialog
                open={Boolean(blogToDelete)}
                itemName={blogToDelete?.topic}
                onClose={() => setBlogToDelete(null)}
                onConfirm={handleDelete}
            />
        </div >
    );
};

export default BlogScreen;
